import React, { useEffect, useState } from "react";
import { fetch } from "../utils/api";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Archive } from "../components/archive";
import { Link, useParams } from "react-router-dom";
import { StaticKv } from "../components/StaticKv";
import dayjs from "dayjs";
import "../assets/styles/column.scss";

export const ColumnDetail = () => {
  const [column, setColumn] = useState<any[]>();
  const [mainColumn, setMainColumn] = useState<any>();

  const { id } = useParams();
  useEffect(() => {
    (async () => {
      try {
        const column = await fetch({
          category: "column",
        });
        if (column.data) setColumn(column.data);
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  useEffect(() => {
    if (column) {
      window.scrollTo(0, 0);
      setMainColumn(
        column.find((column: any) => {
          return Number(column.id) === Number(id);
        })
      );
    }
  }, [id, column]);

  return (
    <div className="page-column">
      <Header>
        <StaticKv title="column" />
      </Header>
      <div className="article-wrapper">
        <Archive data={column} type={"column"} />
        {mainColumn && (
          <div className="article-main">
            <h3 className="article-main_title">{mainColumn.title.rendered}</h3>
            <p className="article-main_date">
              投稿日：{dayjs(mainColumn.date).format("YYYY.MM.DD")}
            </p>
            <div
              className="article-main_text"
              dangerouslySetInnerHTML={{ __html: mainColumn.content.rendered }}
            />
            <div className="all-link">
              <Link to="/column">コラム一覧へ</Link>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};
